<template>
  <v-dialog v-model="dialog" persistent max-width="1500px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn text medium icon v-bind="attrs" v-on="on">
        <v-icon medium color="red lighten-1"> mdi-magnify </v-icon>
      </v-btn>
    </template>
    <v-card class="mx-0">
      <v-app-bar dark dense color="red lighten-1" elevation="0">
        <v-col class="d-flex justify-start">
          <v-toolbar-title>Detalhes de {{ selected_item.description }}</v-toolbar-title>
        </v-col>
        <v-col class="d-flex justify-end">
          <v-btn text medium icon @click="closeModal()">
            <v-icon medium color="white lighten-1" class="mdi-rotate-45"> mdi-plus-circle </v-icon>
          </v-btn>
        </v-col>
      </v-app-bar>
      <v-row class="mx-0">
        <v-col cols="6">
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <strong>Descrição: </strong> <br />{{ selected_item.detailed_description }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <strong>Preço Unitario: </strong> <br />{{ selected_item.unit_price }}
              </v-col>
              <v-col cols="6">
                <strong>Preço Total: </strong><br />
                R$ {{ selected_item.sum_price }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <strong>Numero de Items Adquiridas: </strong> <br />
                {{ selected_item.amount }}
              </v-col>
              <v-col cols="6">
                <strong>Numero de Items Tombados: </strong><br />
                {{ selected_item.number_of_registered }}
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <strong>Lista de Categorias: </strong> <br />
                <b v-for="item in selected_item.item_categories" :key="item.id">
                  [ {{ item.acquisition_category }} ]
                </b>
              </v-col>
            </v-row>
          </v-card-text>
        </v-col>
        <v-col cols="6"> <RegisteredInvoiceItems :itemId="itemId" /> </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import RegisteredInvoiceItems from '@/views/invoice/components/RegisteredInvoiceItems'

export default {
  name: 'InvoiceItemDetailing',
  components: { RegisteredInvoiceItems },
  props: { itemId: Number },
  data() {
    return {
      dialog: false,
      selected_item: {},
      registered_item_number: '',
      selected_item_assets: [],
    }
  },
  created() {
    this.selected_item = this.invoice_items.find((item) => {
      return item.id === this.itemId
    })

    this.selected_item_assets = this.assets.filter((item) => {
      return item.invoice_item_id === this.itemId
    })

    this.registered_item_number = this.selected_item_assets.length
  },
  computed: {
    ...mapState('acquisitions', ['invoice_items']),
    ...mapState('assets', ['assets']),
  },
  watch: {
    invoice_items: function () {
      this.selected_item = this.invoice_items.find((item) => {
        return item.id === this.itemId
      })
    },
    assets: function () {
      this.selected_item_assets = this.assets.filter((item) => {
        return item.invoice_item_id === this.itemId
      })

      this.registered_item_number = this.selected_item_assets.length
    },
  },
  methods: {
    closeModal() {
      this.dialog = false
    },
  },
}
</script>
